import Slider from 'library/components/slider';

const Input = (props) => {
  const handleRemove = (id) => {
    props.onChange(props.value.filter(({ id: deletedId }) => parseInt(deletedId, 10) !== parseInt(id, 10)));
  };

  const handleLike = (id) => {
    props.onChange(props.value.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          isPrimary: item.isPrimary ? null : true,
        };
      }

      if (item.id !== id && item.isPrimary) {
        return {
          ...item,
          isPrimary: null,
        };
      }

      return item;
    }));
  };

  return (
    <>
      <Slider
        data={props.value}
        key="itemImagesSlider"
        onItemRemove={handleRemove}
        onItemLike={handleLike}
        onItemClick={props.onItemClick}
        isEditable={props.isEditable}
      />
      <input type="hidden" ref={props.inputRef} />
    </>
  );
};

export default Input;
